import * as React from "react"
import {Route, Switch} from "react-router-dom"
import * as routes from "../../util/routes"
import InstructionDetail from "./instruction-detail"
import InstructionList from "./instruction-list"

export default class InstructionsComponent extends React.Component {
	render() {
		return (
			<Switch>
				<Route exact path={routes.INSTRUCTIONS} component={InstructionList}/>
				<Route path={routes.INSTRUCTIONS_DETAIL} component={InstructionDetail}/>
			</Switch>
		);
	}
}



// WEBPACK FOOTER //
// ./src/component/instructions/index.tsx